import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { defineCustomElements } from '@ionic/pwa-elements/loader';

// Import function to register Swiper custom elements
import { register } from 'swiper/element/bundle';

if (environment.production) enableProdMode();

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

// Call the element loader after the platform has been bootstrapped
defineCustomElements(window);

// Register Swiper custom elements
register();
